import { $doubleConnectionQuery } from '@/entities/navigation/store'
import { useUnit } from 'effector-react'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { AppButton } from '@/shared/ui/button'
import { goToConnectPlatform, goToMain, goToTon } from '@/app/routing/events'
import { PlatformVariant } from '@/entities/platforms/types'

export const DoubleConnectionErrorView = () => {
  useHideNav()

  const platform = useUnit($doubleConnectionQuery)
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.errors.doubleConnection[platform]
  const rejectFunction = platform === 'steam' ? goToTon : goToMain

  return (
    <div className={classes.doubleConnectionRoot}>
      <BackgroundImage platform={platform} />
      <div className={classes.doubleConnectionContent}>
        <div className={classes.headingAndSteamWrapper}>
          <img
            src={`/assets/social/${platform}.webp`}
            alt=""
            style={{ width: '32px', height: '32px' }}
          />
          <span className={classes.heading}>{texts.heading}</span>
        </div>
        <div>
          <div className={classes.description}>{texts.description}</div>
          <div className={classes.description}>{texts.twice}</div>
        </div>

        <div className={classes.doubleConnectionButtonsWrapper}>
          <AppButton
            onClick={() => goToConnectPlatform({ platform: platform })}
            className={classes.connectAnotherButton}
          >
            {texts.connect_another}
          </AppButton>
          <AppButton
            onClick={() => rejectFunction()}
            className={classes.continueWithoutButton}
          >
            {texts.continue_withiout}
          </AppButton>
        </div>
      </div>
    </div>
  )
}

const BackgroundImage = ({ platform }: { platform: PlatformVariant }) => {
  const { classes } = useStyles()

  if (platform === 'steam') {
    return (
      <img
        className={classes.doubleConnectionBG}
        src="/assets/backgrounds/StartBG.webp"
      />
    )
  }
  if (platform === 'farcana') {
    return (
      <>
        <img
          src="/assets/backgrounds/mike.webp"
          className={classes.mikeImg}
        />
        <img
          className={classes.farcanaBg}
          src="/assets/backgrounds/farcanaGameplay.webp"
        />
      </>
    )
  }
  if (platform === 'egs') {
    return (
      <img
        src="/assets/backgrounds/egsconnectbg.webp"
        className={classes.egsImg}
      />
    )
  }
}
